import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    ref: "golden-layout-data",
    id: "golden-layout-data"
};
const _hoisted_2 = {
    key: 0,
    class: "splash-screen"
};
const _hoisted_3 = { class: "container-fluid p-3" };
const _hoisted_4 = {
    style: { "float": "right", "margin-left": "0.5rem" },
    class: "d-none d-sm-block"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "text-center" };
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_TreeView = _resolveComponent("TreeView");
    const _component_GoldenLayoutComponent = _resolveComponent("GoldenLayoutComponent");
    const _component_PluginPathLink = _resolveComponent("PluginPathLink");
    const _component_Alert = _resolveComponent("Alert");
    const _component_ViewerPanel = _resolveComponent("ViewerPanel");
    const _component_QueuePanel = _resolveComponent("QueuePanel");
    const _component_DataPanel = _resolveComponent("DataPanel");
    const _component_LogPanel = _resolveComponent("LogPanel");
    const _component_GoldenLayoutContainer = _resolveComponent("GoldenLayoutContainer");
    const _component_StylesPanel = _resolveComponent("StylesPanel");
    const _component_InformationPanel = _resolveComponent("InformationPanel");
    return (_openBlock(), _createElementBlock("span", null, [
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_GoldenLayoutContainer, { type: "column" }, {
                default: _withCtx(() => [
                    _createVNode(_component_GoldenLayoutContainer, {
                        type: "row",
                        height: 100
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_GoldenLayoutComponent, {
                                name: "Navigator",
                                extraClass: "sortable-group",
                                state: "{}",
                                width: 20
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", {
                                        onClick: _cache[0] || (_cache[0] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => (_ctx.clearSelection && _ctx.clearSelection(...args)), ["self"])),
                                        style: { "height": "100%", "overflow-x": "clip" }
                                    }, [
                                        _createVNode(_component_TreeView)
                                    ])
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_GoldenLayoutContainer, {
                                type: "stack",
                                width: 60
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_GoldenLayoutComponent, {
                                        name: "Viewer",
                                        state: "{}",
                                        style: 'height:100%; padding:0 !important;'
                                    }, {
                                        default: _withCtx(() => [
                                            (!_ctx.viewerLoaded)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                                    _createElementVNode("div", _hoisted_3, [
                                                        _createElementVNode("div", _hoisted_4, [
                                                            _createElementVNode("img", {
                                                                src: _ctx.logoPath,
                                                                class: "rounded mx-auto d-block",
                                                                alt: "Logo",
                                                                style: { "width": "128px", "height": "128px" }
                                                            }, null, 8, _hoisted_5),
                                                            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.appInfo), 1)
                                                        ]),
                                                        _createElementVNode("p", null, [
                                                            _createElementVNode("span", { innerHTML: _ctx.appDescription }, null, 8, _hoisted_7),
                                                            _createTextVNode(" " + _toDisplayString(_ctx.appName) + " is freely accessible for personal, academic, and commercial use, without login or registration. ", 1)
                                                        ]),
                                                        _createElementVNode("p", null, [
                                                            _cache[1] || (_cache[1] = _createTextVNode(" To get started, take a look at the ", -1)),
                                                            _createVNode(_component_PluginPathLink, {
                                                                plugin: "help",
                                                                title: _ctx.appName + ' Help System'
                                                            }, null, 8, ["title"]),
                                                            _cache[2] || (_cache[2] = _createTextVNode(", read the ", -1)),
                                                            _createVNode(_component_PluginPathLink, {
                                                                plugin: "documentation",
                                                                title: "documentation"
                                                            }),
                                                            _cache[3] || (_cache[3] = _createTextVNode(", or load some ", -1)),
                                                            _createVNode(_component_PluginPathLink, {
                                                                plugin: "openexampleproject",
                                                                title: "example data"
                                                            }),
                                                            _cache[4] || (_cache[4] = _createTextVNode(". ", -1))
                                                        ]),
                                                        (!_ctx.isChromeBrowser)
                                                            ? (_openBlock(), _createBlock(_component_Alert, {
                                                                key: 0,
                                                                type: "warning"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(" We test " + _toDisplayString(_ctx.appName) + " on many browsers to ensure it works well everywhere. However, if you experience any unexpected issues, consider Chrome for a smoother experience. ", 1)
                                                                ]),
                                                                _: 1
                                                            }))
                                                            : _createCommentVNode("", true),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalMessages, (msg) => {
                                                            return (_openBlock(), _createBlock(_component_Alert, {
                                                                key: msg.text,
                                                                type: msg.type
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(msg.text), 1)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["type"]));
                                                        }), 128)),
                                                        (_ctx.activityFocusModeInfo[0] !== 'All')
                                                            ? (_openBlock(), _createBlock(_component_Alert, {
                                                                key: 1,
                                                                type: "info"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(" You are running " + _toDisplayString(_ctx.appName) + " in ", 1),
                                                                    _createElementVNode("b", null, _toDisplayString(_ctx.activityFocusModeInfo[0]), 1),
                                                                    _createTextVNode(" mode. In this mode, " + _toDisplayString(_ctx.appName) + " hides some tools so you can " + _toDisplayString(_ctx.activityFocusModeInfo[1]) + " ", 1),
                                                                    _createElementVNode("a", { href: _ctx.standardModeUrl }, "Switch to All mode", 8, _hoisted_8),
                                                                    _cache[5] || (_cache[5] = _createTextVNode(" to restore access to all tools. ", -1))
                                                                ]),
                                                                _: 1
                                                            }))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createVNode(_component_ViewerPanel, { onOnViewerLoaded: _ctx.onViewerLoaded }, null, 8, ["onOnViewerLoaded"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_GoldenLayoutComponent, {
                                        name: "Jobs",
                                        state: "{}"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_QueuePanel)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_GoldenLayoutComponent, {
                                        name: "Data",
                                        state: "{}"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_DataPanel)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_GoldenLayoutComponent, {
                                        name: "Log",
                                        state: "{}",
                                        paddingSize: 2
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_LogPanel)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_GoldenLayoutContainer, {
                                type: "column",
                                width: 20
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_GoldenLayoutComponent, {
                                        name: "Styles",
                                        state: "{}",
                                        width: 20,
                                        height: 66
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_StylesPanel)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_GoldenLayoutComponent, {
                                        name: "Information",
                                        state: "{}",
                                        width: 20,
                                        height: 34
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_InformationPanel)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            })
        ], 512),
        _cache[6] || (_cache[6] = _createElementVNode("div", { id: "golden-layout" }, null, -1))
    ]));
}
